// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-HUQty","legend":"jgp-1bplf"};